export const CHAT_ICON = '/assets/images/misc/chat.webp';
export const HEALTH_PROVIDER_COPY = {
  title: 'talk to a healthcare professional online',
  body: 'Connect with an independent licensed healthcare professional to discuss your birth control options.',
  button: 'Talk to a healthcare professional',
};

export const NURSE_NAVIGATOR_COPY = {
  title: 'nurse navigator',
  body: 'Connect with an independent licensed healthcare professional to discuss your birth control options.',
  button: 'Talk to a healthcare professional ',
};

export const BULLETS_INFORMATION = [
  {
    image: {
      src: '/assets/images/misc/answer-icon.webp',
      width: 68,
      height: 81,
      alt: 'Answer icon, Nexplanon',
    },
    copy: 'Answer a few questions',
  },
  {
    image: {
      src: '/assets/images/misc/money-icon.webp',
      width: 88,
      height: 45,
      alt: 'Money icon, Nexplanon',
    },
    copy: 'A $20 fee will be charged by UpScript.',
  },
  {
    image: {
      src: '/assets/images/misc/steth-icon.webp',
      width: 48,
      height: 79,
      alt: 'Steth icon, Nexplanon',
    },
    copy: 'Schedule an appointment with an independent licensed healthcare professional',
  },
];
